import React, {useState, useEffect} from "react";
import {ViewAcademy, ThinTitle, TextAca} from "./AcademyStyles";
import {Content} from "../../../styles/GlobalStyles";
import Color from "../../../assets/Colors";
import {ActionBio, CardWhiteCoach, CardCoach} from "../../course_details/components/FacilitadorStyle";
import {ContentContainer} from "../../../styles/Products";
import parse from "html-react-parser";
import VideoModal from "../../modals/VideoModal";

export default function Bienvenida({data}) {
   const [isMobile, setMobile] = useState(true);

   useEffect(() => {
      setMobile(window.screen.width < 500);
   }, []);
   if (isMobile) {
      return (
         <>
            <ViewAcademy>
               <Content>
                  <ContentContainer>
                     <CardCoach width="100%" className="full">
                        <img src={`http://domecqapi.trebolbit.com/${data.pathImageWebDesktop}`} alt="experience" className="profileImg" />
                        <CardWhiteCoach>
                           <ThinTitle color={Color.primary}>BIENVENIDO A DOMECQ ACADEMY</ThinTitle>
                           {/* <TextAca>
                           Enrique Murillo, nuestro CEO, te da la bienvenida a esta gran familia, nuestra casa, Casa Pedro Domecq.
                        </TextAca> */}
                           <TextAca>{parse(data.description)}</TextAca>
                           <ActionBio to="/domecq_academy?videoBienvenida=true">
                              Ver video
                              <span>
                                 <img src={require("../../../assets/icons/media.png")} alt="next" className="mediaIcon" />
                              </span>
                           </ActionBio>
                        </CardWhiteCoach>
                     </CardCoach>
                  </ContentContainer>
               </Content>
            </ViewAcademy>
            <VideoModal videoUrl={data.pathVideo} initiator="videoBienvenida" />
         </>
      );
   }

   return (
      <>
         <ViewAcademy>
            <Content>
               <ContentContainer>
                  <CardCoach width="100%" className="full">
                     <img src={`http://domecqapi.trebolbit.com/${data.pathImageWebDesktop}`} alt="experience" className="profileImg" />
                     <CardWhiteCoach>
                        <ThinTitle color={Color.primary}>BIENVENIDO A DOMECQ ACADEMY</ThinTitle>
                        {/* <TextAca>
                        Enrique Murillo, nuestro CEO, te da la bienvenida a esta gran familia, nuestra casa, Casa Pedro Domecq.
                     </TextAca> */}
                        <TextAca>{parse(data.description)}</TextAca>
                        <ActionBio to="/domecq_academy?videoBienvenida=true">
                           Ver video
                           <span>
                              <img src={require("../../../assets/icons/media.png")} alt="next" className="mediaIcon" />
                           </span>
                        </ActionBio>
                     </CardWhiteCoach>
                  </CardCoach>
               </ContentContainer>
            </Content>
         </ViewAcademy>
         <VideoModal videoUrl={data.pathVideo} initiator="videoBienvenida" />
      </>
   );
}
